module.exports = __webpack_public_path__ + "img/appAsset--documents-ax.3cfb4915.svg";